import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';



@Injectable({
  providedIn: 'root'
})
export class CentroDeAyudaService {
  private mailApiURL = `${environment.apiUrl}sendEmail`;

  constructor(private http: HttpClient) { }

  PostMessage(input: any): Observable<any> {
    return this.http.post(this.mailApiURL, input, { responseType: 'text' })
      .pipe(
        map(
          (response) => {
            if (response) {
              return response;
            }
          },
          (error: any) => {
            return error;
          }
        )
      );
  }


  // login(user: string, pass: string): any {
  //   pass = this.hashPassword(pass);
  //   const request = new  ILoginReq(user, pass);
  //   return this.http.post<any>(environment.apiUrl + 'login', request, { observe: 'response' }).pipe(map(data => {
  //     if (data.status === 200) {
  //       console.log(data);
  //       let user = new User();
  //       user = data.body;
  //       user.isLogged = true;
  //       this.currentUserSubject.next(user);
  //       localStorage.setItem('currentUser', JSON.stringify(user));
  //     }
  //   }));
  // }
}
